import React from "react";
import {Checkbox, FormControl, FormControlLabel, Typography} from "@mui/material";
import {makeLxTranslations, useLxTranslations} from "@lxo-blocks/react";

const MFA_TOTP_REMEMBER_DEVICE_CHECKBOX_TRANSLATION = makeLxTranslations({
    namespace: "mfaTotpRememberDeviceCheckboxTranslations",
    translations: {
        REMEMBER_DEVICE: "Für die nächsten 90 Tage in diesem Browser nicht mehr nachfragen.",
    }
})

export const MfaTotpRemeberDeviceFormCheckbox = React.forwardRef<any, any>((props, ref) => {
    const {t} = useLxTranslations(MFA_TOTP_REMEMBER_DEVICE_CHECKBOX_TRANSLATION);
    const {sx, ...rest} = props;
    return (
        <FormControl sx={sx}>
            <FormControlLabel
                label={<Typography component="div" variant="body2">{t("REMEMBER_DEVICE").toString()}</Typography>}
                control={
                    <Checkbox
                        {...rest}
                        ref={ref}
                        size="small"
                        checked={rest.value}
                        onChange={(event) =>
                            rest.onChange(event.target.checked)}
                        inputProps={{
                            "aria-label": "RememberDevice"
                        }}
                    />}
            />
        </FormControl>
    );
});
